import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
// import { history } from 'app/history';
import {
  get_Countrycodes,
  occupation_Data,
  get_MStatus,
  get_FamilyStatus,
  get_FamilyValue,
  get_FamilyType,
  aboutme_page,
  contact_page,
  detailsList
} from './api';

const initialState = {
  loading: false,
  createContactDetailsloading: false,
  country_codes: [],
  Occupation_Data: [],
  maritial_Status: [],
  family_Status: [],
  family_Value: [],
  family_Type: [],
  siblings_maritialStatus: [],
  get_hobbies_list: [],
  get_sports_list: [],
  education_details: [],
  department_details: [],
  city_details: [],
  user_data: []
};

const actions = {
  COUNTRYCODES: 'countryCodes/COUNTRYCODES',
  OCCUPATIONDATA: 'occupationData/OCCUPATIONDATA',
  MARITIAL_STATUS: 'maritialStatus/MARITIAL_STATUS',
  FAMILY_STATUS: 'familyStatus/FAMILY_STATUS',
  FAMILY_VALUE: 'familyValue/FAMILY_VALUE',
  FAMILY_TYPE: 'familyType/FAMILY_TYPE',
  SIBLINGS_MARITIAL_STATUS: 'siblings_maritial_Status/SIBLINGS_MARITIAL_STATUS',
  HOBBIES_LIST: 'hobbies_list/HOBBIES_LIST',
  SPORTS_LIST: 'sports_list/SPORTS_LIST',
  EDUCATION_LIST: 'education_list/EDUCATION_LIST',
  DEPARTMENT_LIST: 'department_list/DEPARTMENT_LIST',
  CITIES_LIST: 'cities_list/CITIES_LIST',
  CREATE_ABOUTME: 'createAboutme/CREATE_ABOUTME',
  CREATE_CONTACTDETAILS: 'createContactDetails/CREATE_CONTACTDETAILS',
  GET_BYID: 'get_byID/GET_BYID'
};

export const get_byID = createAsyncThunk(actions.GET_BYID, async (payload) => {
  const response = await detailsList(payload);
  return response;
});

export const countryCodes = createAsyncThunk(
  actions.COUNTRYCODES,
  async (payload) => {
    const response = await get_Countrycodes('countries-list', payload);
    return response;
  }
);
// occupationData/OCCUPATIONDATA
export const occupationData = createAsyncThunk(
  actions.OCCUPATIONDATA,
  async (payload) => {
    const response = await occupation_Data('occupations-list', payload);
    return response;
  }
);
// maritialStatus/MARITIAL_STATUS
export const maritialStatus = createAsyncThunk(
  actions.MARITIAL_STATUS,
  async (payload) => {
    const response = await get_MStatus('marital-status-list', payload);
    return response;
  }
);
// familyStatus/FAMILY_STATUS
export const familyStatus = createAsyncThunk(
  actions.FAMILY_STATUS,
  async (payload) => {
    const response = await get_FamilyStatus('family-status-list', payload);
    return response;
  }
);
// familyValue/FAMILY_VALUE
export const familyValue = createAsyncThunk(
  actions.FAMILY_VALUE,
  async (payload) => {
    const response = await get_FamilyValue('family-values-list', payload);
    return response;
  }
);
// familyType/FAMILY_TYPE
export const familyType = createAsyncThunk(
  actions.FAMILY_TYPE,
  async (payload) => {
    const response = await get_FamilyType('family-types-list', payload);
    return response;
  }
);
// siblings_maritialStatus/SIBLINGS_MARITIAL_STATUS
export const siblings_maritial_Status = createAsyncThunk(
  actions.SIBLINGS_MARITIAL_STATUS,
  async (payload) => {
    const response = await get_MStatus('marital-status-list', payload);
    return response;
  }
);
// hobbies_list/HOBBIES_LIST
export const hobbies_list = createAsyncThunk(
  actions.HOBBIES_LIST,
  async (payload) => {
    const response = await get_MStatus('hobby-sports-list', payload);
    return response;
  }
);
// sports_list/SPORTS_LIST
export const sports_list = createAsyncThunk(
  actions.SPORTS_LIST,
  async (payload) => {
    const response = await get_MStatus('hobby-sports-list', payload);
    return response;
  }
);
// education_list/EDUCATION_LIST
export const education_list = createAsyncThunk(
  actions.EDUCATION_LIST,
  async (payload) => {
    const response = await get_MStatus('higher-education-list', payload);
    return response;
  }
);
// department_list/DEPARTMENT_LIST
export const department_list = createAsyncThunk(
  actions.DEPARTMENT_LIST,
  async (payload) => {
    const response = await get_MStatus('departments-list', payload);
    return response;
  }
);
// cities_list/CITIES_LIST
export const cities_list = createAsyncThunk(
  actions.CITIES_LIST,
  async (payload) => {
    const response = await get_MStatus('cities-list', payload);
    return response;
  }
);

// createAboutme/CREATE_ABOUTME
export const createAboutme = createAsyncThunk(
  actions.CREATE_ABOUTME,
  async (payload) => {
    const response = await aboutme_page(payload);
    return response;
  }
);

// createContactDetails/CREATE_CONTACTDETAILS
export const createContactDetails = createAsyncThunk(
  actions.CREATE_CONTACTDETAILS,
  async (payload) => {
    const response = await contact_page('contact-info', payload);
    return response;
  }
);

export const EditContactSlice = createSlice({
  name: 'editcontact',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(countryCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(countryCodes.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.country_codes = data;
      })
      .addCase(countryCodes.rejected, (state) => {
        state.loading = false;
      });

    // occupationData
    builder
      .addCase(occupationData.pending, (state) => {
        state.loading = true;
      })
      .addCase(occupationData.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.Occupation_Data = data;
      })
      .addCase(occupationData.rejected, (state) => {
        state.loading = false;
      });

    // maritialStatus
    builder
      .addCase(maritialStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(maritialStatus.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.maritial_Status = data;
      })
      .addCase(maritialStatus.rejected, (state) => {
        state.loading = false;
      });

    // familyStatus
    builder
      .addCase(familyStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(familyStatus.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.family_Status = data;
      })
      .addCase(familyStatus.rejected, (state) => {
        state.loading = false;
      });

    // familyValue
    builder
      .addCase(familyValue.pending, (state) => {
        state.loading = true;
      })
      .addCase(familyValue.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.family_Value = data;
      })
      .addCase(familyValue.rejected, (state) => {
        state.loading = false;
      });

    // familyType
    builder
      .addCase(familyType.pending, (state) => {
        state.loading = true;
      })
      .addCase(familyType.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.family_Type = data;
      })
      .addCase(familyType.rejected, (state) => {
        state.loading = false;
      });

    // siblings_maritialStatus
    builder
      .addCase(siblings_maritial_Status.pending, (state) => {
        state.loading = true;
      })
      .addCase(siblings_maritial_Status.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.siblings_maritialStatus = data;
      })
      .addCase(siblings_maritial_Status.rejected, (state) => {
        state.loading = false;
      });

    // hobbies_list
    builder
      .addCase(hobbies_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(hobbies_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.get_hobbies_list = data;
      })
      .addCase(hobbies_list.rejected, (state) => {
        state.loading = false;
      });

    // sports_list
    builder
      .addCase(sports_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(sports_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.get_sports_list = data;
      })
      .addCase(sports_list.rejected, (state) => {
        state.loading = false;
      });

    // education_list
    builder
      .addCase(education_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(education_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.education_details = data;
      })
      .addCase(education_list.rejected, (state) => {
        state.loading = false;
      });

    // department_list
    builder
      .addCase(department_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(department_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.department_details = data;
      })
      .addCase(department_list.rejected, (state) => {
        state.loading = false;
      });

    // cities_list
    builder
      .addCase(cities_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(cities_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.city_details = data;
      })
      .addCase(cities_list.rejected, (state) => {
        state.loading = false;
      });

    // createAboutme
    builder
      .addCase(createContactDetails.pending, (state) => {
        state.createContactDetailsloading = true;
      })
      .addCase(createContactDetails.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('slice_data', action.payload);
        state.createContactDetailsloading = false;
        state.city_details = data;
      })
      .addCase(createContactDetails.rejected, (state) => {
        state.createContactDetailsloading = false;
      });

    builder
      .addCase(get_byID.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(get_byID.fulfilled, (state, action) => {
        const { data } = action.payload;
        console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        state.user_data = data;

        // console.log('slicelog', data);
      })
      .addCase(get_byID.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });
  }
});

export default EditContactSlice.reducer;
